import React from 'react';

const ResourcesSVG = (props) => {
  return (
    <svg
      {...props}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="11.5" r="11.5" className="resources-SVG" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.75736 7.75729H16.2426V16.2426L14.7292 16.2178L14.7292 10.3128L8.27839 16.7636L7.23633 15.7215L11.457 11.5009L13.6871 9.27075L7.75736 9.24593L7.75736 7.75729Z"
        fill="white"
      />
    </svg>
  );
};

const DocumentSVG = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.89093 4.36251e-05H11.4787L12.4637 1.0502L17.0141 5.89088L18 6.93998V19.9876C18 21.0946 17.1482 22 16.1078 22H1.89125C0.850849 22 0 21.0946 0 19.9876V2.01244C0 0.905369 0.850521 4.36251e-05 1.89093 4.36251e-05ZM11.4787 1.04915H1.89093C1.39228 1.04915 0.985438 1.48206 0.985438 2.01266V19.9869C0.985438 20.5175 1.39228 20.9494 1.89093 20.9494H16.1083C16.6069 20.9494 17.0137 20.5165 17.0137 19.9869V6.9402H13.369C12.3286 6.9402 11.4777 6.03483 11.4777 4.92776L11.4776 1.04945L11.4787 1.04915Z"
      />
    </svg>
  );
};

const DownloadSVG = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.0069 19.9088V22.5441C24.0069 22.7303 24.0094 22.9141 23.9845 23.1002C23.9969 23.0208 24.0094 22.9391 24.0193 22.8596C23.9869 23.0616 23.9272 23.2591 23.84 23.4475C23.8723 23.3749 23.9072 23.3022 23.9396 23.2296C23.8524 23.4135 23.7403 23.5837 23.6058 23.7426C23.6581 23.6813 23.7104 23.62 23.7627 23.5587C23.6332 23.7063 23.4887 23.8402 23.3242 23.9582C23.3915 23.9106 23.4588 23.8629 23.526 23.8152C23.3516 23.9378 23.1648 24.0399 22.963 24.1194C23.0427 24.0899 23.1224 24.0581 23.2022 24.0286C22.9954 24.108 22.7786 24.1625 22.5569 24.192C22.6441 24.1807 22.7338 24.1693 22.821 24.1602C22.6042 24.1852 22.3875 24.1807 22.1683 24.1807H21.1792H17.8008H13.6751H10.1472C9.60912 24.1807 9.07095 24.1829 8.53279 24.1807C8.41569 24.1807 8.29611 24.1739 8.17901 24.1602C8.26621 24.1716 8.3559 24.1829 8.4431 24.192C8.22136 24.1625 8.00461 24.108 7.79783 24.0286C7.87755 24.0581 7.95728 24.0899 8.037 24.1194C7.8352 24.0399 7.64835 23.9378 7.47396 23.8152C7.54123 23.8629 7.6085 23.9106 7.67577 23.9582C7.51383 23.8402 7.36684 23.7085 7.23728 23.5587C7.2896 23.62 7.34192 23.6813 7.39424 23.7426C7.2597 23.5837 7.14759 23.4135 7.06039 23.2296C7.09278 23.3022 7.12766 23.3749 7.16005 23.4475C7.07285 23.2591 7.01305 23.0616 6.98067 22.8596C6.99312 22.9391 7.00558 23.0208 7.01555 23.1002C6.96074 22.7212 6.99312 22.3216 6.99312 21.9403V20.2969V19.9088C6.99312 19.4343 6.53473 18.9781 5.99656 19.0008C5.45594 19.0235 5 19.4003 5 19.9088V22.3489C5 22.8256 4.99751 23.3023 5.16693 23.7608C5.34132 24.2352 5.61787 24.6642 5.99907 25.0251C6.38028 25.386 6.83869 25.6312 7.34693 25.8105C7.95233 26.0261 8.60257 25.9989 9.24037 25.9989H11.6869H15.0653H18.5457H21.3012C21.6923 25.9989 22.0835 26.0012 22.4747 25.9989C23.4288 25.9944 24.3855 25.6357 25.0358 24.9933C25.6587 24.3804 26 23.5882 26 22.7552V20.1675V19.9133C26 19.4389 25.5416 18.9826 25.0034 19.0053C24.4628 19.0235 24.0069 19.4003 24.0069 19.9088V19.9088Z" />
      <path d="M14.005 7.97943V9.18063V12.0527V15.5363V18.5381C14.005 19.0249 13.9938 19.5118 14.005 19.9985V20.0206C14.005 20.5319 14.6927 21.0236 15.5 20.9991C16.311 20.9747 16.995 20.5686 16.995 20.0206V18.8194V15.9473V12.4637V9.46192C16.995 8.97508 17.0062 8.48824 16.995 8.00145V7.97943C16.995 7.46812 16.3073 6.97641 15.5 7.00088C14.689 7.02534 14.005 7.43144 14.005 7.97943Z" />
      <path d="M16.9009 20.6815C17.4395 20.1425 17.9754 19.6063 18.5139 19.0673C19.3707 18.2099 20.2274 17.3525 21.087 16.4923C21.2851 16.294 21.4805 16.0985 21.6786 15.9002C22.0916 15.4869 22.1223 14.7273 21.6786 14.3195C21.2321 13.909 20.54 13.8783 20.0991 14.3195C19.5605 14.8586 19.0246 15.3948 18.4861 15.9337C17.6293 16.7911 16.7726 17.6485 15.913 18.5087C15.7149 18.707 15.5195 18.9025 15.3214 19.1008C14.9084 19.5141 14.8777 20.2738 15.3214 20.6815C15.7679 21.0892 16.46 21.1228 16.9009 20.6815Z" />
      <path d="M15.6815 19.0991C15.1425 18.5605 14.6063 18.0246 14.0673 17.4861C13.2099 16.6293 12.3525 15.7726 11.4923 14.913C11.294 14.7149 11.0985 14.5195 10.9002 14.3214C10.4869 13.9084 9.72726 13.8777 9.31953 14.3214C8.90899 14.7679 8.87827 15.46 9.31953 15.9009C9.85855 16.4395 10.3948 16.9754 10.9337 17.5139C11.7911 18.3707 12.6485 19.2274 13.5087 20.087C13.707 20.2851 13.9025 20.4805 14.1008 20.6786C14.5141 21.0916 15.2738 21.1223 15.6815 20.6786C16.0892 20.2321 16.1228 19.54 15.6815 19.0991Z" />
    </svg>
  );
};

const ExternalLinkSVG = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.4 22.6C23.4 23.0444 23.0444 23.4 22.6 23.4H9.4C8.9556 23.4 8.6 23.0444 8.6 22.6V9.4C8.6 8.9556 8.95559 8.6 9.4 8.6H14.6V7H9.4C8.06659 7 7 8.06663 7 9.4V22.6C7 23.9334 8.06663 25 9.4 25H22.6C23.9334 25 25 23.9334 25 22.6V17.4H23.4V22.6Z" />
      <path d="M17.5764 6.00004V7.77344H22.9705L16 14.7439L17.2561 16L24.2266 9.02956V14.4236H26V6L17.5764 6.00004Z" />
    </svg>
  );
};

const ArrowSVG = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 7.99999L15.2239 7.0012L9.76547 0L7.71002 1.99759L11.2068 6.47799H0V9.52199H11.2068L7.71002 14.0024L9.76547 16L15.2239 8.99878L16 7.99999Z" />
    </svg>
  );
};

export { ResourcesSVG, ArrowSVG, ExternalLinkSVG, DownloadSVG, DocumentSVG };
